import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import {
  AuthenticationResult,
  EventType,
  InteractionType,
} from "@azure/msal-browser";
import { authEnabled, msalInstance } from "./common/auth/authConfig";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const appTree = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

if (authEnabled && msalInstance) {
  const instance = msalInstance;
  // msal-browser v3+ requires initialize() before any other MSAL API is used.
  instance.initialize().then(() => {
    // Default to the first account if no active account is set.
    if (!instance.getActiveAccount() && instance.getAllAccounts().length > 0) {
      instance.setActiveAccount(instance.getAllAccounts()[0]);
    }

    // Keep the active account in sync after each successful login.
    instance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        instance.setActiveAccount(payload.account);
      }
    });

    root.render(
      <MsalProvider instance={instance}>
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
          {appTree}
        </MsalAuthenticationTemplate>
      </MsalProvider>
    );
  });
} else {
  root.render(appTree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
